import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AESEncryptDecryptService } from '../services/aesencrypt-decrypt.service';
import { LocalService } from '../services/local.service';
import { Router } from '@angular/router';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApicallService {
  userName: any;
  authToken: any;
  user: any;
  role: any;
  permissions: any;
  routeEnabled: Boolean = false;
  globalDate: any;
  AIRASIA_STATE_CODE =  '06';
  GST_RATE = 18;
  HSN_CODE = '9985';
  path: any;
  showRoute: boolean = true;

  constructor(
    private http: HttpClient,
    private _AESEncryptDecryptService: AESEncryptDecryptService,
    private localService: LocalService,
    private router: Router
  ) { }

  getCSRFToken(): string {

    const characters = '0123456789abcdef';
    let randomToken = '';

    for (let i = 0; i < 32; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      randomToken += characters.charAt(randomIndex);
    }

   // console.log('cookies',randomToken)
    return randomToken;

    // return _csrf;

    // const allCookies = document.cookie;
    // const cookies = document.cookie.split('; ');
    // // const name = cookies.split('=');
    // console.log('cookies',allCookies)
    // for (const cookie of cookies) {
    //   const [name, value] = cookie.split('=');
    //   if (name === '_csrf') {
    //     return decodeURIComponent(value); // Decode the URI-encoded value
    //   }
    // }
    // return '';
  }


  authenticateUser(user) {
    const key = this._AESEncryptDecryptService.generateKey();
    user = this._AESEncryptDecryptService.encrypt(user, key);
    const csrfToken = this.getCSRFToken();
    let headers = new HttpHeaders({ 'Content-Type': 'application/json','X-XSRF-TOKEN': csrfToken,'Access-Control-Allow-Origin': '*','X-Frame-Options': 'DENY','X-Content-Type-Options':'nosniff','X-XSS-Protection':'1; mode=block'});
    return this.http.post('/api/user/login', user, { headers: headers, withCredentials: true }).pipe(map(res => this._AESEncryptDecryptService.decrypt(res, key)));
  }

  destryeeSession(user){
    const key = this._AESEncryptDecryptService.generateKey();
    user = this._AESEncryptDecryptService.encrypt(user, key);
    const csrfToken = this.getCSRFToken();
    let headers = new HttpHeaders({'Content-Type': 'application/json','X-XSRF-TOKEN': csrfToken,'Access-Control-Allow-Origin': '*','X-Frame-Options': 'DENY','X-Content-Type-Options':'nosniff','X-XSS-Protection':'1; mode=block'});
    return this.http.post('/api/user/logout', user, {headers: headers}).pipe(map(res=> this._AESEncryptDecryptService.decrypt(res, key)));
  }

  authenticateAgent(user) {
    const key = this._AESEncryptDecryptService.generateKey();
    user = this._AESEncryptDecryptService.encrypt(user, key);
    const csrfToken = this.getCSRFToken();
    let headers = new HttpHeaders({ 'Content-Type': 'application/json','X-XSRF-TOKEN': csrfToken,'Access-Control-Allow-Origin': '*','X-Frame-Options': 'DENY','X-Content-Type-Options':'nosniff','X-XSS-Protection':'1; mode=block' });
    return this.http.post('/api/agent/login', user, { headers: headers }).pipe(map(res => this._AESEncryptDecryptService.decrypt(res, key)));
  }

  requestResetPassword(username) {
    const key = this._AESEncryptDecryptService.generateKey();
    username = this._AESEncryptDecryptService.encrypt(username, key);
    const csrfToken = this.getCSRFToken();
    let headers = new HttpHeaders({ 'Content-Type': 'application/json','X-XSRF-TOKEN': csrfToken,'Access-Control-Allow-Origin': '*','X-Frame-Options': 'DENY','X-Content-Type-Options':'nosniff','X-XSS-Protection':'1; mode=block' });
    return this.http.post('/api/user/request-password-reset', username, { headers: headers }).pipe(map(res => this._AESEncryptDecryptService.decrypt(res, key)));
  }

  resetPassword(username) {
    const key = this._AESEncryptDecryptService.generateKey();
    username = this._AESEncryptDecryptService.encrypt(username, key);
    const csrfToken = this.getCSRFToken();
    let headers = new HttpHeaders({ 'Content-Type': 'application/json','X-XSRF-TOKEN': csrfToken,'Access-Control-Allow-Origin': '*','X-Frame-Options': 'DENY','X-Content-Type-Options':'nosniff','X-XSS-Protection':'1; mode=block' });
    return this.http.post('/api/user/reset-password', username, { headers: headers }).pipe(map(res => this._AESEncryptDecryptService.decrypt(res, key)));
  }

  triggerService(params) {
    //console.log(params);
    const key = this._AESEncryptDecryptService.generateKey();
    const csrfToken = this.getCSRFToken();
    params = this._AESEncryptDecryptService.encrypt(params, key);
    let headers = new HttpHeaders({'Authorization': this.authToken ,'X-XSRF-TOKEN': csrfToken,'Access-Control-Allow-Origin': '*','X-Frame-Options': 'DENY','X-Content-Type-Options':'nosniff','X-XSS-Protection':'1; mode=block'});
    return this.http.post('/api/trigger/Service', params, { headers: headers }).pipe(
      catchError(err => {
        if (err.status === 401) {
          this.logout();
          this.router.navigate(['/']);
        }
        return null;
      }),
      map(res => {
        let decryptedRes = this._AESEncryptDecryptService.decrypt(res, key);
        return decryptedRes;
      }));
  }

  sendPdf(file) {
    let formData: FormData = new FormData();
    formData.append('file', file[0]);
    let headers = new HttpHeaders({ 'Authorization': this.authToken });
    return this.http.post('/api/send/pdf', formData, { headers: headers }).pipe(map(res => res));
  }

  sendAgentFile(file) {
    let formData: FormData = new FormData();
    formData.append('file', file[0]);
    let headers = new HttpHeaders({ 'Authorization': this.authToken });
    return this.http.post('/api/agent_send/file', formData, { headers: headers }).pipe(map(res => res));
  }

  sendUserFile(file) {
    let formData: FormData = new FormData();
    formData.append('file', file[0]);
    let headers = new HttpHeaders({ 'Authorization': this.authToken });
    return this.http.post('/api/user_send/file', formData, { headers: headers }).pipe(map(res => res));
  }

  pushFile(file, folderName) {
    let formData: FormData = new FormData();
    formData.append('file', file[0]);
    let headers = new HttpHeaders({ 'Authorization': this.authToken, 'folderName': folderName });
    return this.http.post('/api/user/push_file', formData, { headers: headers }).pipe(map(res => res));
  }

  checkVersion(param) {
    const key = this._AESEncryptDecryptService.generateKey();
    param = this._AESEncryptDecryptService.encrypt(param, key);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post('/api/version/check', param, { headers: headers }).pipe(map(res => this._AESEncryptDecryptService.decrypt(res, key)));
  }

  getValidationArray(data) {
    if (data.data === undefined)
      return data.response_text;
    const array = data.data;
    let returnString: any = "";
    for (var key in array) {
      returnString = returnString.replace(".", ", ") + array[key];
    }
    return returnString;
  }

  storeUserData(token, user, path, version) {
    this.localService.setJsonValue('id_token', token);
    this.localService.setJsonValue('user', JSON.stringify(user));
    this.localService.setJsonValue('path_url', JSON.stringify(path));
    this.localService.setJsonValue('version', version);
    this.authToken = token;
    this.user = user;
    this.path = path;
    this.role = this.user.roles[0].type;
    this.permissionArray(this.user.roles);
    this.routeEnabled = !this.hasNull(this.user);
  }

  permissionArray(roles) {
    if (this.user.hasOwnProperty('agent_name')) {
      this.userName = this.user.agent_name;
    }
    if (this.user.hasOwnProperty('username')) {
      this.userName = this.user.username;
    }
    let array = [];
    for (var i = 0; i < roles.length; i++) {
      array = array.concat(roles[i]['permissions']);
    }
    this.permissions = array;
  }

  loadUser() {
    this.showRoute = false;
    const version = this.localService.getJsonValue('version');
    const user = this.localService.getJsonValue('user');
    this.user = JSON.parse(`${user}`);
    this.role = this.user.roles[0].type;
    this.permissionArray(this.user.roles);
    if (version == null) {
      this.routeEnabled = false;
      this.logout();
      setTimeout(() => {
        this.router.navigate(['/']);
      }, 10);
      return;
    }
    const params = {
      version
    }
    this.checkVersion(params).subscribe(data => {
      if (data.flag == false) {
        this.routeEnabled = false;
        this.localService.clearToken();
        this.router.navigate(['/']);
        setTimeout(() => {
          this.showRoute = true;
        }, 1000);
        return;
      } else {
        this.routeEnabled = !this.hasNull(this.user);
        this.showRoute = true;
      }
    })
    return this.user;
  }

  loadPath() {
    const path = this.localService.getJsonValue('path_url');
    this.path = JSON.parse(`${path}`);
  }

  loadToken() {
    const token = this.localService.getJsonValue('id_token');
    this.authToken = token;
  }

  loggedIn() {
    const jwtHelper = new JwtHelperService();
    const token = this.localService.getJsonValue('id_token');
    return !jwtHelper.isTokenExpired(token);
  }

  logout() {
    this.authToken = null;
    this.user = null;
    this.role = null;
    this.permissions = null;
    this.userName = null;
    this.path = null
    this.routeEnabled = false;
    this.localService.clearToken();
  }

  hasNull(target): boolean {
    for (var member in target) {
      if (target[member] == null)
        return true;
    }
    return false;
  }

  urdAcknowledgeService(param) {
    const key = this._AESEncryptDecryptService.generateKey();
    param = this._AESEncryptDecryptService.encrypt(param, key);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': this.authToken });
    return this.http.post('/api/trigger/Service', param, { headers: headers }).pipe(map(res => this._AESEncryptDecryptService.decrypt(res, key)));
  }
}
